<template>
  <div>
    <div class="container-fluid px-0">
      <div class="d-flex flex-column flex-lg-row">
        <div class="order-2 order-lg-1 col-lg-7 px-0 bg-wolf">
          <div class="container">
            <div class="row">
              <div class="col-12">
                <div class="thanks">
                  <div class="text-center">
                    <router-link to="/">
                      <img
                        class="thanks__logo"
                        src="../assets/images/logo.svg"
                        alt
                      />
                    </router-link>
                  </div>
                  <h1 class="thanks__headline">
                    Strona nie istnieje
                  </h1>
                  <div class="text-center"><router-link to="/" class="form__submit text-white" >Strona główna</router-link></div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
        <div class="order-1 order-lg-1 col-lg-5 px-0">
            <img
                src="../assets/images/wolf/wolf_bg.jpg"
                class="form__video d-none d-lg-block"
        />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
export default {
  name: "PageNotFound",
  title: "Strony nie odnaleziono",
  components: {
    Footer,
  },
};
</script>
